<template>
  <container 
    subHeaderTitle="자주 찾는<br /><b>서비스 안내</b>"
    subHeaderText="항상 핀브릿지를 이용해 주셔서 감사합니다. 어떻게 도와드릴까요?<br />1688-4102<span class='px-3'>|</span>help@finbridge.co.kr"
  >
    <section class="cs-safeguard">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div class="box">
              <v-row>
                <v-col cols="12" sm="8">
                  <div class="text-area">
                    <p class="text-title">세이프가드·금융사기방지</p>
                    <p class="text-content">안전한 금융 거래를 위해 <br class="br-pc" />국내 모든 금융기관 24시간 모니터링 및 알림 제공</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn outlined rounded block color="white" @click.stop="openExternalPage($event, supportJoinUrls.safeguard)" class="mb-4"
                  :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label1" :data-ga-action="gaEvent.actions.buttonClick">가입하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'PassSafeguardCompensation')" class="mb-4"
                  :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label2" :data-ga-action="gaEvent.actions.buttonClick">신청하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'PassSafeguardTermination')" class="mb-4"
                  :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label3" :data-ga-action="gaEvent.actions.buttonClick">해지하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'Refund')"
                   :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label3" :data-ga-action="gaEvent.actions.buttonClick">환불하기</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="cs-safebilling">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div class="box">
              <v-row>
                <v-col cols="12" sm="8">
                  <div class="text-area">
                    <p class="text-title">세이프빌링</p>
                    <p class="text-content">상해입원, 치명적 장애, 비자발적 실업에 대비한 <br class="br-pc" />통신비 지원 서비스</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
<!--                  <v-btn outlined rounded block color="white" @click.stop="$router.push({ name: 'SafebillingContract' })" class="mb-4">가입하기</v-btn>-->
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'SafebillingCompensation')"  class="mb-4"
                  :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label4" :data-ga-action="gaEvent.actions.buttonClick">신청하기</v-btn>
<!--                  <v-btn outlined rounded block color="white" @click.stop="$router.push({ name: 'SafebillingTermination' })">해지하기</v-btn>-->
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="cs-passprime">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div class="box">
              <v-row>
                <v-col cols="12" sm="8">
                  <div class="text-area">
                    <p class="text-title">PASS프라임</p>
                    <p class="text-content">신용정보, 금융인증, 주식정보 등<br class="br-pc" />필요한 정보를 모니터링하고 알림 제공</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn outlined rounded block color="white" @click.stop="openExternalPage($event, supportJoinUrls.passPrime)" class="mb-4"
                  :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label5" :data-ga-action="gaEvent.actions.buttonClick">가입하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'PassPrimeTermination')"
                  :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label6" :data-ga-action="gaEvent.actions.buttonClick">해지하기</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="cs-safeid">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div class="box">
              <v-row>
                <v-col cols="12" sm="8">
                  <div class="text-area">
                    <p class="text-title">정보유출 안심케어</p>
                    <p class="text-content">불법 유통되고 있는 개인정보<br class="br-pc" />실시간 조회 및 모니터링</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn outlined rounded block color="white" @click="openSafeidExternalPage()" class="mb-4"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label7" :data-ga-action="gaEvent.actions.buttonClick">가입하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'SafeidTermination')" class="mb-4"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label8" :data-ga-action="gaEvent.actions.buttonClick">해지하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'Refund')"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label3" :data-ga-action="gaEvent.actions.buttonClick">환불하기</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="cs-jws">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div class="box">
              <v-row>
                <v-col cols="12" sm="8">
                  <div class="text-area">
                    <p class="text-title">전월세 안심케어</p>
                    <p class="text-content">등기부등본 분석을 통한 전월세 사기 위험도 분석<br class="br-pc" />각종 할인 쿠폰 및 사기 피해 보상금 지원</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn outlined rounded block color="white" @click.stop="openExternalPage($event, jwsUrls.join)" class="mb-4"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label9" :data-ga-action="gaEvent.actions.buttonClick">가입하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="openExternalPage($event, jwsUrls.termination)" class="mb-4"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label10" :data-ga-action="gaEvent.actions.buttonClick">해지하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'Refund')"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label11" :data-ga-action="gaEvent.actions.buttonClick">환불하기</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="cs-ftutor">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" xl="8" offset-xl="2" class="py-0">
            <div class="box">
              <v-row>
                <v-col cols="12" sm="8">
                  <div class="text-area">
                    <p class="text-title">AI가족금융튜터</p>
                    <p class="text-content">초·중·고 맞춤형 금융 콘텐츠와 퀴즈로<br class="br-pc" />온 가족의 금융 학습을 돕는 서비스</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-btn outlined rounded block color="white" @click.stop="openExternalPage($event, ftutorUrls.join)" class="mb-4"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label13" :data-ga-action="gaEvent.actions.buttonClick">가입하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="openExternalPage($event, ftutorUrls.termination)" class="mb-4"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label14" :data-ga-action="gaEvent.actions.buttonClick">해지하기</v-btn>
                  <v-btn outlined rounded block color="white" @click.stop="movePage($event, 'Refund')"
                         :data-ga-category="gaEvent.category.support.main.name" :data-ga-label="gaEvent.category.support.main.label12" :data-ga-action="gaEvent.actions.buttonClick">환불하기</v-btn>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </container>
</template>

<style lang="scss" scoped>
@import "@/styles/support";
</style>

<script>
import Container from "@/pages/container/index.vue";
import {GaTracking} from "@/mixins/index.js";
export default {
  mixins: [GaTracking],
  name: "Support",
  components: {
    Container
  },
  props: {},
  data() {
    return {
      supportJoinUrls: {
        safeguard: process.env.VUE_APP_SG_EXT_URL + "?chanCd=F100",
        passPrime: process.env.VUE_APP_PRIME_EXT_URL + "skt?chanCd=F100"
      },
      // 전월세안심케어는 가입·해지 화면을 전월세(homecare) 서비스가 제공하므로 외부 URL 로 연결한다
      jwsUrls: {
        join: process.env.VUE_APP_JWS_URL + "/signup/?utm_content=v1_s_0&ch=home",
        termination: process.env.VUE_APP_JWS_URL + "/cancel/"
      },
      // 금융튜터 가입·해지는 알티너스 공통 외부 가입창·해지창(vas-frontend)이 금융튜터 사이트에 제공한다
      // 가입창은 utm_content 의 디자인 키가 없으면 가입 화면 대신 안내 화면을 띄우므로 함께 보낸다
      ftutorUrls: {
        join: process.env.VUE_APP_FTUTOR_URL + "/signup/?utm_content=adult_s_0&ch=home",
        termination: process.env.VUE_APP_FTUTOR_URL + "/cancel/"
      }
    };
  },
  computed: {},
  watch: {},
  methods: {
    movePage(e, paramName){
      this.gaTracking(e);
      this.$router.push({ name: paramName});
    },
    openExternalPage(e, url) {
      this.gaTracking(e);
      window.open(url, "_blank");
    },
    openSafeidExternalPage() {
      window.open(process.env.VUE_APP_SAFEID + "/external?chanCd=hp", "_blank");
    }
  },
  created() {}
};
</script>